/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { injectable } from 'inversify'
import { IStateCodeApiClient } from './contracts'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import { IStateCode } from '../StateCodeStateManager/contracts'
import axios from 'axios'
import { ErrorHelper } from '../../utils/ErrorHelper'
import { IState } from '../AccountFacilityStateManager/contracts'

@injectable()
export class StateCodeApiClient implements IStateCodeApiClient {
	apiBaseUrl: string

	constructor() {
		this.apiBaseUrl = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}`
	}

	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	get(id: number): Promise<IStateCode> {
		const url = `${this.apiBaseUrl}/statecodes/${id}`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)
			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}

	getAllStates(): Promise<IState[]> {
		const params = `Limit=${200}`
		const url = `${this.apiBaseUrl}/statecodes?${params}`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data.items)
			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}
}
